import { action } from "@ember/object"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import type { Group } from "@shared/models/group"
import type { User } from "@shared/models/user"
import { handleError } from "cc-frontend/error-handling"
import type Dialog from "cc-frontend/services/dialog"
import type Rpc from "cc-frontend/services/rpc"

interface Sig {
  Args: {
    group: Group
    user: User
  }
}

export default class PotentialGroup extends Component<Sig> {
  @service declare dialog: Dialog
  @service declare rpc: Rpc

  @tracked isRpcInProgress = false

  get isAdmin(): boolean {
    return ["admin", "district-admin"].includes(this.args.user.attributes.educationRole)
  }

  get groupType() {
    return this.args.group.attributes.usedAs === "school-network" ? "district" : "school"
  }

  @action
  requestMembership() {
    this.rpc
      .group_request_membership({
        groupId: this.args.group.id,
        membershipLevel: this.isAdmin ? "admin" : "teacher",
      })
      .then(() => {
        if (this.isDestroyed || this.isDestroying) return
        later(() => (this.isRpcInProgress = false), 250)
      })
  }

  @action
  cancelMembership() {
    this.dialog
      .blank("dialogs/confirm-cancel-membership-potential", {
        className: "dialog--create-annotation",
      })
      .then(() => {
        this.isRpcInProgress = true
        this.rpcToCancelMembership(this.args.group.id)
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }

  rpcToCancelMembership(groupId: string) {
    this.rpc
      .group_cancel_other_membership({
        groupId,
        membershipType: "group-membership-potential",
      })
      .then(() => {
        if (this.isDestroyed || this.isDestroying) return
        later(() => (this.isRpcInProgress = false), 250)
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Users::Home::PotentialGroup": typeof PotentialGroup
  }
}
